import * as React from 'react';
import l10n from '../../util/l10n';

import ModuleData from './ModuleData';

import { WebViewProps } from '../interfaces';

import ModulFliestext from '../ModulFliestext';

export interface TextWebViewProps extends WebViewProps<ModuleData>, React.Props<TextWebView> {
    module: ModulFliestext;
}

export default class TextWebView extends React.Component<TextWebViewProps, {}> {

    private textElement: HTMLElement;

    componentDidMount() {
        this.props.module.initCKEditor(this.textElement);
    }

    render() {
        const text = this.props.payload.text === ''
            ?  '<< ' + l10n('module.text.newtext') + ' >>'
            :
            this.props.payload.text;
        /* TODO: Handle links replacement. */
        return (
            <div
                ref={(textElement) => this.textElement = textElement}
                dangerouslySetInnerHTML={{ __html: text }}
            />
        );
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/text/WebView.tsx
 **/